export enum PackageType {
    Package = 'Package',
    Promo = 'Promo',
  }